import { useEffect, useState } from "react";
import axios from "axios";

export const SubjectStats = ({ API, profile, refreshKey }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    axios.get(`${API}/crm/subject-stats`, { params: { profile } })
      .then(({ data }) => setRows(data.rows)).catch(() => {});
  }, [API, profile, refreshKey]);

  if (!rows.length) return null;
  const best = {};
  rows.forEach((r) => { if (r.sent >= 5 && r.reply_rate > (best[r.step]?.reply_rate ?? -1)) best[r.step] = r; });
  return (
    <div data-testid="crm-subject-stats" className="mt-3 pt-3 border-t border-slate-100">
      <div className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-2">Per onderwerp</div>
      <table className="w-full text-xs">
        <thead className="text-slate-400">
          <tr><th className="text-left py-1">Mail</th><th className="text-left py-1">Onderwerp</th><th className="text-right py-1">Verzonden</th>
            <th className="text-right py-1">Reacties</th><th className="text-right py-1">Klanten</th></tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} data-testid={`crm-subject-row-${i}`} className={`border-t border-slate-100 ${best[r.step] === r ? "bg-emerald-50" : ""}`}>
              <td className="py-1.5 text-slate-500">{r.step}</td>
              <td className="py-1.5 pr-2 text-slate-800 max-w-[260px] truncate" title={r.subject}>{r.subject.split(/(\{\{\w+\}\})/).map((p, k) => (/^\{\{\w+\}\}$/.test(p) ? <span key={k} className="text-slate-400">{p}</span> : p))}{best[r.step] === r && <span className="ml-1.5 text-[10px] font-semibold text-emerald-700">beste</span>}</td>
              <td className="py-1.5 text-right tabular-nums">{r.sent}</td>
              <td className="py-1.5 text-right tabular-nums">{r.replied} <span className="text-slate-400">({r.reply_rate}%)</span></td>
              <td className="py-1.5 text-right tabular-nums">{r.customers} <span className="text-slate-400">({r.customer_rate}%)</span></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
